import React from 'react';

import { UserRoleValue } from '../../Common/UserRole';
import { UserRole } from '../UserRole';
import localStorage from '../LocalStorage';
import { generateUserRole } from '../Helpers';

import LocalizedStrings from 'react-localization';
import { translations } from '../../Common/Translations';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

export class AddRoleSelect extends React.Component {
    generateSelect = () => {
        let isDisabled = false;

        if (localStorage.getUsernameRole() === UserRole.PHARMACY_MANAGER) {
            isDisabled = true;
        }

        return (
            <select onChange={this.props.handler} disabled={isDisabled}>
                <option value="">{isDisabled ? 'Pharmacist' : this.props.placeholder}</option>
                {(generateUserRole(this.props.status) || []).map(role => (
                    <option key={role.title} value={role.value}>
                        {strings[role.value]}
                    </option>
                ))}
            </select>
        );
    };

    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class AddCompanyAdminSelect extends React.Component {
    generateSelect = () => {
        let listOfCompanies = this.props.companyList.companies ? this.props.companyList.companies : this.props.companyList;

        return (
            <select onChange={this.props.handler}>
                <option>{this.props.placeholder}</option>
                {(listOfCompanies || []).map(company => (
                    <option key={company.id} value={company.id}>
                        {company.name}
                    </option>
                ))}
            </select>
        );
    };
    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class AddCompanyOwnerSelect extends React.Component {
    generateSelect = () => {
        let listOfCompanies = this.props.companyList.companies ? this.props.companyList.companies : this.props.companyList;

        return (
            <select onChange={this.props.handler} disabled={true}>
                <option value="">{this.props.placeholder}</option>
                {(listOfCompanies || []).map(company => (
                    <option key={company.id} value={company.id}>
                        {company.name}
                    </option>
                ))}
            </select>
        );
    };
    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class AddCompanyManagerSelect extends React.Component {
    generateSelect = () => {
        let listOfCompanies = this.props.companyList.companies ? this.props.companyList.companies : this.props.companyList;

        return (
            <select onChange={this.props.handler} disabled={true}>
                <option value="">{this.props.placeholder}</option>
                {(listOfCompanies || []).map(company => (
                    <option key={company.id} value={company.id}>
                        {company.name}
                    </option>
                ))}
            </select>
        );
    };
    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class AddPharmacyAdminSelect extends React.Component {
    generateSelect = () => {
        let isDisabled = false;
        let roleOfRoleSelect = this.props.role;
        let listOfPharmacies = this.props.pharmacyList.pharmacies ? this.props.pharmacyList.pharmacies : this.props.pharmacyList;

        if (roleOfRoleSelect === UserRoleValue.STORE_OWNER) {
            isDisabled = true;
        }
        return (
            <select onChange={this.props.handler} disabled={isDisabled}>
                <option value="">{this.props.placeholder}</option>
                {(listOfPharmacies || []).map(pharmacy => (
                    <option key={pharmacy.id} value={pharmacy.id}>
                        {pharmacy.name}
                    </option>
                ))}
            </select>
        );
    };

    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class AddPharmacyOwnerSelect extends React.Component {
    generateSelect = () => {
        let listOfPharmacies = this.props.pharmacyList.pharmacies ? this.props.pharmacyList.pharmacies : this.props.pharmacyList;

        return (
            <select onChange={this.props.handler}>
                <option value="">{this.props.placeholder}</option>
                {(listOfPharmacies || []).map(pharmacy => (
                    <option key={pharmacy.id} value={pharmacy.id}>
                        {pharmacy.name}
                    </option>
                ))}
            </select>
        );
    };

    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class AddPharmacyManagerSelect extends React.Component {
    generateSelect = () => {
        let listOfPharmacies = this.props.pharmacyList.pharmacies ? this.props.pharmacyList.pharmacies : this.props.pharmacyList;

        return (
            <select onChange={this.props.handler} disabled={true}>
                <option value="">{this.props.placeholder}</option>
                {(listOfPharmacies || []).map(pharmacy => (
                    <option key={pharmacy.id} value={pharmacy.id}>
                        {pharmacy.name}
                    </option>
                ))}
            </select>
        );
    };

    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Common/form/Selects-add.js